import { Helmet } from 'react-helmet-async';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import {
  Card,
  Container,
  Typography,
  Grid,
  FormControlLabel,
  Switch,
  Box,
  TextField,
  Slider,
  CardHeader,
  Stack,
  Tooltip,
  InputAdornment,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import useMediaQuery from '@mui/material/useMediaQuery';
import EditIcon from '@mui/icons-material/Edit';
//--------------------------------------------------------
import { CustomAutocomplete, CustomTimeField, CustomTextField, CustomDatePicker } from '../../utils/StyledInputs';
import { DefaultContainedButton, DefaultOutlinedButton } from '../../utils/Buttons';
import { LoadingUI } from '../../utils/LayoutStyles';
import ageRanges from '../../model/ageRanges';
import { EntitiesDialog } from '../../utils/EntitiesDialog';
import API from '../../api';

dayjs.locale('it');

export default function NewNewsletter() {
  // general
  const isSmallScreen = useMediaQuery('(min-width: 600px)');
  const [apiCalled, setApiCalled] = useState(false);
  const [currentProfile, setCurrentProfile] = useState('');

  // newsletter info
  const [newsletterTypeList, setNewsletterTypeList] = useState([]);
  const [newsletterStatusList, setNewsletterStatusList] = useState([]);

  // get api calls for regions, provinces, positions, entity types and entities
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [regionsResponse, provincesResponse, positionsResponse] = await axios.all([
          API.get('/regions'),
          API.get('/provinces'),
          API.get('/positions'),
        ]);

        getNewslettersData();

        setRegionsList(regionsResponse.data);
        setProvincesList(provincesResponse.data);
        setPositionsList(positionsResponse.data);

        setApiCalled(true);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  // Get Newsletter types, Statuses and Filters
  const getNewslettersData = () => {
    API.get('/newslettertypes').then((response) => {
      setNewsletterTypeList(response.data.data);
    });

    API.get('newsletterstatus').then((response) => {
      setNewsletterStatusList(response.data.newsletter_statuses);
    });
  };

  const [openEntitiesFilter, setOpenEntitiesFilter] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState(null);

  const handleCloseEntitiesFilterDialog = () => {
    setOpenEntitiesFilter(false);
  };

  const getSelectedEntity = (selectedEntity) => {
    setSelectedEntity(selectedEntity);
  };

  const [openPositionEntitiesFilter, setOpenPositionEntitiesFilter] = useState(false);
  const [selectedPositionEntity, setSelectedPositionEntity] = useState(null);

  const handleClosePositionEntitiesFilterDialog = () => {
    setOpenPositionEntitiesFilter(false);
  };

  const getSelectedPositionEntity = (selectedEntity) => {
    setSelectedPositionEntity(selectedEntity);
  };

  // filters info
  const [regionsList, setRegionsList] = useState([]);
  const [provincesList, setProvincesList] = useState([]);
  const [disableRegion, setDisableRegion] = useState(false);
  const [disableProvince, setDisableProvince] = useState(false);
  const [region, setRegion] = useState([]);
  const [province, setProvince] = useState([]);

  // enable / disable region by province
  useEffect(() => {
    if (province.length !== 0) {
      setDisableRegion(true);
    } else {
      setDisableRegion(false);
    }
  }, [province]);

  // enable / disable province by region
  useEffect(() => {
    if (region.length !== 0) {
      setDisableProvince(true);
    } else {
      setDisableProvince(false);
    }
  }, [region]);

  // filter by age range
  const [ageRange, setAgeRange] = useState(null);

  // filter by signed up from
  const [signedUpFrom, setSignedUpFrom] = useState([0, 51]);
  const [changedSlider, setChangedSlider] = useState(false);

  // signed up from slide
  const handleChangeSlider = (e, newValue, activeThumb) => {
    const minDistance = 1;

    if (!Array.isArray(newValue)) {
      return;
    }

    if (activeThumb === 0) {
      setSignedUpFrom([Math.min(newValue[0], signedUpFrom[1] - minDistance), signedUpFrom[1]]);
    } else {
      setSignedUpFrom([signedUpFrom[0], Math.max(newValue[1], signedUpFrom[0] + minDistance)]);
    }

    setChangedSlider(true);
  };

  // Slider Last Value Label
  const valueLabelFormat = () => {
    if (signedUpFrom[1] === 51) {
      return 'Sempre';
    }
    return signedUpFrom[1];
  };

  // Filter By Positions
  const [positionsList, setPositionsList] = useState([]);
  const [position, setPosition] = useState([]);
  const [positionEntity, setPositionEntity] = useState([]);

  // Filter By Entities
  const [entity, setEntity] = useState([]);

  // Newsletter Texts
  const [object, setObject] = useState('');
  const [text, setText] = useState('');

  // Flter Selections
  const [filterAll, setFilterAll] = useState(false);
  const [filterAdv, setFilterAdv] = useState(false);
  const [filterPosition, setFilterPosition] = useState(false);
  const [filterEntity, setFilterEntity] = useState(false);

  const [filterDisabled, setFilterDisabled] = useState({
    filterAll: false,
    filterAdv: false,
    filterPosition: false,
    filterEntity: false,
  });

  // Filter All Change
  const handleFilterAllChange = () => {
    setFilterAll(!filterAll);
  };
  useEffect(() => {
    if (filterAll) {
      setFilterDisabled((prevState) => ({
        ...prevState,
        filterAdv: true,
        filterPosition: true,
        filterEntity: true,
      }));

      setRegion([]);
      setProvince([]);
      setAgeRange(null);
      setChangedSlider(false);
      setPosition([]);
      setSelectedPositionEntity(null);
      setSelectedEntity(null);
    } else {
      setFilterDisabled((prevState) => ({
        ...prevState,
        filterAdv: false,
        filterPosition: false,
        filterEntity: false,
      }));
    }
  }, [filterAll]);

  // Filter Adv Change
  const handleFilterAdvChange = () => {
    setFilterAdv(!filterAdv);
  };
  useEffect(() => {
    if (filterAdv) {
      setFilterDisabled((prevState) => ({
        ...prevState,
        filterAll: true,
        filterPosition: true,
        filterEntity: true,
      }));

      setPosition([]);
      setSelectedPositionEntity(null);
      setSelectedEntity(null);
    } else {
      setFilterDisabled((prevState) => ({
        ...prevState,
        filterAll: false,
        filterPosition: false,
        filterEntity: false,
      }));
    }
  }, [filterAdv]);
  useEffect(() => {
    if (
      (region !== null && region !== undefined && region !== '' && region.length !== 0) ||
      (province !== null && province !== undefined && province !== '' && province.length !== 0) ||
      (ageRange !== null && ageRange !== undefined && ageRange !== '' && ageRange.length !== 0) ||
      (signedUpFrom !== null && signedUpFrom !== undefined && signedUpFrom !== '' && changedSlider)
    ) {
      setFilterAdv(true);
    } else {
      setFilterAdv(false);
    }
  }, [region, province, ageRange, signedUpFrom]);

  // Filter position Change
  const handleFilterOfficeChange = () => {
    setFilterPosition(!filterPosition);
  };
  useEffect(() => {
    if (filterPosition) {
      setFilterDisabled((prevState) => ({
        ...prevState,
        filterAll: true,
        filterAdv: true,
        filterEntity: true,
      }));

      setRegion([]);
      setProvince([]);
      setAgeRange(null);
      setChangedSlider(false);
      setSelectedEntity(null);
    } else {
      setFilterDisabled((prevState) => ({
        ...prevState,
        filterAll: false,
        filterAdv: false,
        filterEntity: false,
      }));
    }
  }, [filterPosition]);
  useEffect(() => {
    if (
      (position !== null && position !== undefined && position !== '' && position.length !== 0) ||
      (selectedPositionEntity !== null &&
        selectedPositionEntity !== undefined &&
        selectedPositionEntity !== '' &&
        selectedPositionEntity.length !== 0)
    ) {
      setFilterPosition(true);
    } else {
      setFilterPosition(false);
    }
  }, [position, selectedPositionEntity]);

  // Filter Entity Change
  const handleFilterEntityChange = () => {
    setFilterEntity(!filterEntity);
  };
  useEffect(() => {
    if (filterEntity) {
      setFilterDisabled((prevState) => ({
        ...prevState,
        filterAll: true,
        filterAdv: true,
        filterPosition: true,
      }));

      setRegion([]);
      setProvince([]);
      setAgeRange(null);
      setChangedSlider(false);
      setPosition([]);
      setSelectedPositionEntity(null);
    } else {
      setFilterDisabled((prevState) => ({
        ...prevState,
        filterAll: false,
        filterAdv: false,
        filterPosition: false,
      }));
    }
  }, [filterEntity]);
  useEffect(() => {
    if (
      selectedEntity !== null &&
      selectedEntity !== undefined &&
      selectedEntity !== '' &&
      selectedEntity.length !== 0
    ) {
      setFilterEntity(true);
    } else {
      setFilterEntity(false);
    }
  }, [selectedEntity]);

  // Newsletter Sending Datetime
  const [programmedNewsletter, setProgrammedNewsletter] = useState(false);
  const today = dayjs();
  const [sendingDate, setSendingDate] = useState(null);
  const [sendingDateIsToday, setSendingDateIsToday] = useState(true);
  const [sendingTime, setSendingTime] = useState(null);

  // change newsletter sending date / time
  const handleChangeProgrammedNewsletter = () => {
    setProgrammedNewsletter(!programmedNewsletter);
  };

  useEffect(() => {
    if (sendingDate) {
      const todayYear = today.$y;
      const todayMonth = today.$M + 1;
      const todayDay = today.$D;

      const selectedYear = sendingDate.$y;
      const selectedMonth = sendingDate.$M + 1;
      const selectedDay = sendingDate.$D;

      if (selectedYear === todayYear && selectedMonth === todayMonth && selectedDay === todayDay) {
        setSendingDateIsToday(true);
      } else {
        setSendingDateIsToday(false);
      }
    }
  }, [sendingDate]);

  // create new newsletter
  const createNewsletter = (e) => {
    e.preventDefault();

    const newsletter = {
      filterAll,
      filterAdv,
      filterPosition,
      filterEntity,
      region,
      province,
      ageRange: ageRange ? ageRange.range : ageRange,
      signedUpFrom: signedUpFrom ? signedUpFrom.time : signedUpFrom,
      position,
      entity,
      object,
      text,
      sending_date: dayjs(sendingDate).format('YYYY/MM/DD'),
      sending_time: dayjs(sendingTime).format('YYYY/MM/DD'),
    };

    const creationUser = JSON.parse(localStorage.getItem('userData'));

    const newNews = {
      subject: object,
      body: text,
      attachment: null,
      z_newsletter_status_id: newsletterStatusList[1].id,
      z_newsletter_type_id: newsletterTypeList[1].id,
      z_newsletter_filter_id: '9abed7ff-01b4-4c61-99a0-37ff6e5d3a3b',
      z_office_id: '9abed7ff-22d0-4b25-b03e-79533a32298d',
      entity_id: '9abed7fe-1e08-4822-aeea-629acc7536f6',
      creation_user: creationUser.id,
    };

    API.post(`/newsletters`, newNews)
      .then((response) => {})
      .catch((error) => {});
  };

  // get user data
  useEffect(() => {
    let data;

    if (localStorage.getItem('userData') !== 'undefined') data = JSON.parse(localStorage.getItem('userData'));

    if (data) {
      const _currentProfile = data.roles.filter((role) => role.last_used);
      setCurrentProfile(_currentProfile);
    }
  }, []);

  if (currentProfile && currentProfile[0].prof_type_name !== 'ADMIN') return <Navigate to={{ pathname: '/' }} />;

  return (
    <>
      <Helmet>
        <title>Nuova Newsletter </title>
      </Helmet>

      <Container maxWidth="xl">
        <EntitiesDialog
          openDialog={openEntitiesFilter}
          closeDialog={handleCloseEntitiesFilterDialog}
          outputEntity={getSelectedEntity}
          context={'newsletter'}
        />

        <EntitiesDialog
          openDialog={openPositionEntitiesFilter}
          closeDialog={handleClosePositionEntitiesFilterDialog}
          outputEntity={getSelectedPositionEntity}
          context={'newsletter'}
        />

        {apiCalled ? (
          // Content
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <form style={{ display: 'flex', flexDirection: 'column', gap: '24px' }} onSubmit={createNewsletter}>
                {/* Newsletter Filters */}
                <Card sx={{ padding: '24px' }}>
                  <Stack direction={isSmallScreen ? 'row' : 'column'} alignItems="start" gap="24px">
                    {/* Left Filters */}
                    <Grid container spacing={3}>
                      {/* Select All */}
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={filterAll}
                              disabled={filterDisabled.filterAll}
                              onChange={handleFilterAllChange}
                            />
                          }
                          label="Tutti"
                        />
                      </Grid>
                      {/* Advanced Selection */}
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={filterAdv}
                              disabled={filterDisabled.filterAdv}
                              onChange={handleFilterAdvChange}
                            />
                          }
                          label="Selezione Avanzata"
                        />
                        {/* Region */}
                        <Box sx={{ paddingTop: '24px' }}>
                          <CustomAutocomplete
                            multiple
                            limitTags={5}
                            disabled={filterDisabled.filterAdv || disableRegion}
                            value={region}
                            options={regionsList}
                            isOptionEqualToValue={(option, value) => option.region_name === value.region_name}
                            getOptionLabel={(option) => (option ? option.region_name : '')}
                            onChange={(e, value) => {
                              setRegion(value);
                            }}
                            renderInput={(params) => <TextField {...params} label="Regione" variant="outlined" />}
                          />
                        </Box>
                        {/* Province */}
                        <Box sx={{ paddingTop: '24px' }}>
                          <CustomAutocomplete
                            multiple
                            limitTags={5}
                            disabled={filterDisabled.filterAdv || disableProvince}
                            value={province}
                            options={provincesList}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            getOptionLabel={(option) => option.name}
                            renderOption={(props, option) => (
                              <Box component="li" {...props} key={option.id}>
                                {option.name}
                              </Box>
                            )}
                            onChange={(e, value) => {
                              setProvince(value);
                            }}
                            renderInput={(params) => <TextField {...params} label="Provincia" variant="outlined" />}
                          />
                        </Box>
                        {/* Age Range */}
                        <Box sx={{ paddingTop: '24px' }}>
                          <CustomAutocomplete
                            disabled={filterDisabled.filterAdv}
                            value={ageRange}
                            options={ageRanges}
                            onChange={(e, value) => {
                              setAgeRange(value);
                            }}
                            getOptionLabel={(option) => option.range}
                            renderInput={(params) => <TextField {...params} label="Età" variant="outlined" />}
                          />
                        </Box>
                        {/* Signed Up From */}
                        <Box sx={{ paddingTop: '24px', margin: '0 4px' }}>
                          <Slider
                            min={0}
                            max={51}
                            disabled={filterDisabled.filterAdv}
                            value={signedUpFrom}
                            onChange={handleChangeSlider}
                            valueLabelDisplay="auto"
                            valueLabelFormat={valueLabelFormat}
                            disableSwap
                          />

                          {!filterDisabled.filterAdv && signedUpFrom[1] !== 51 ? (
                            <Typography>
                              Utenti registrati da {signedUpFrom[1]} {signedUpFrom[1] === 1 ? 'anno' : 'anni'}
                            </Typography>
                          ) : (
                            <Typography>Nessuna selezione per tempo di iscrizione</Typography>
                          )}
                        </Box>
                      </Grid>
                    </Grid>

                    {/* Right Filters */}
                    <Grid container spacing={3}>
                      {/* position */}
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={filterPosition}
                              disabled={filterDisabled.filterPosition}
                              onChange={handleFilterOfficeChange}
                            />
                          }
                          label="Selezione per Carica"
                        />

                        {/* Entity */}
                        <Box sx={{ paddingTop: '24px' }}>
                          {!selectedPositionEntity ? (
                            <DefaultOutlinedButton
                              disabled={filterDisabled.filterPosition}
                              customStyles={{ width: '100%' }}
                              onClick={() => setOpenPositionEntitiesFilter(!openPositionEntitiesFilter)}
                            >
                              Cerca Entità
                            </DefaultOutlinedButton>
                          ) : (
                            <Grid container spacing={3}>
                              <Grid item xs={12}>
                                <CustomTextField
                                  disabled={filterDisabled.filterPosition}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                                        <Tooltip title="Modifica" placement="left" arrow>
                                          <EditIcon
                                            onClick={() => setOpenPositionEntitiesFilter(!openPositionEntitiesFilter)}
                                          />
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                  value={selectedPositionEntity.name}
                                  label="Entità"
                                />
                              </Grid>
                            </Grid>
                          )}
                        </Box>

                        {/* position */}
                        <Box sx={{ paddingTop: '24px' }}>
                          <CustomAutocomplete
                            multiple
                            limitTags={5}
                            disabled={filterDisabled.filterPosition}
                            value={position}
                            options={positionsList}
                            getOptionLabel={(option) => option.name}
                            onChange={(e, value) => {
                              setPosition(value);
                            }}
                            renderInput={(params) => <TextField {...params} label="Carica" variant="outlined" />}
                          />
                        </Box>
                      </Grid>

                      {/* Entity */}
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={filterEntity}
                              disabled={filterDisabled.filterEntity}
                              onChange={handleFilterEntityChange}
                            />
                          }
                          label="Selezione per Entità"
                        />
                        {/* Entity */}
                        <Box sx={{ paddingTop: '24px' }}>
                          {!selectedEntity ? (
                            <DefaultOutlinedButton
                              disabled={filterDisabled.filterEntity}
                              customStyles={{ width: '100%' }}
                              onClick={() => setOpenEntitiesFilter(!openEntitiesFilter)}
                            >
                              Cerca Entità
                            </DefaultOutlinedButton>
                          ) : (
                            <Grid container spacing={3}>
                              <Grid item xs={12}>
                                <CustomTextField
                                  disabled={filterDisabled.filterEntity}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end" sx={{ cursor: 'pointer' }}>
                                        <Tooltip title="Modifica" placement="left" arrow>
                                          <EditIcon onClick={() => setOpenEntitiesFilter(!openEntitiesFilter)} />
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                  value={selectedEntity.name}
                                  label="Entità"
                                />
                              </Grid>
                            </Grid>
                          )}
                        </Box>
                      </Grid>
                    </Grid>
                  </Stack>
                </Card>

                <Card sx={{ padding: '24px' }}>
                  <Box sx={{ display: 'flex' }}>
                    <Switch checked={programmedNewsletter} onChange={handleChangeProgrammedNewsletter} />

                    <CardHeader sx={{ padding: 0 }} title="Programma Invio" />
                  </Box>
                  {programmedNewsletter && (
                    <Grid sx={{ paddingTop: '12px' }} container spacing={3}>
                      {/* Date */}
                      <Grid item xs={12} md={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                          <DemoContainer components={['DatePicker']}>
                            <CustomDatePicker
                              disabled={!programmedNewsletter}
                              disablePast
                              label="Data Invio"
                              value={sendingDate}
                              onChange={(newValue) => setSendingDate(newValue)}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>

                      {/* Time */}
                      <Grid item xs={12} md={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                          <DemoContainer components={['TimeField']}>
                            <CustomTimeField
                              disabled={!programmedNewsletter}
                              disablePast={sendingDateIsToday}
                              label="Orario Invio"
                              value={sendingTime}
                              onChange={(newValue) => setSendingTime(newValue)}
                              format="HH:mm"
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  )}
                </Card>

                {/* Newsletter Texts */}
                <Card sx={{ padding: '24px' }}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <CustomTextField
                        fullWidth
                        label="Oggetto"
                        onChange={(e) => {
                          setObject(e.currentTarget.value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <CustomTextField
                        rows="5"
                        fullWidth
                        multiline
                        label="Inserisci il testo"
                        onChange={(e) => {
                          setText(e.currentTarget.value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <DefaultContainedButton type="submit">Invia Newsletter</DefaultContainedButton>
                    </Grid>
                  </Grid>
                </Card>
              </form>
            </Grid>
          </Grid>
        ) : (
          LoadingUI()
        )}
      </Container>
    </>
  );
}
